module.exports = __webpack_public_path__ + "assets/media/message-bubble.04b802cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookPickBotStep/message-bubble.svg
// module id = 3122
// module chunks = 0